import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminAuthContext } from '../../AdminAuthContext';
import axios from 'axios';
import './AdminCountries.css'; // Reuse existing styles for consistency

const AddCountryForm = () => {
  const { admin, loading } = useContext(AdminAuthContext);
  const [formData, setFormData] = useState({
    Country: '',
    Shipping_Cost: '',
    Taxes: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const token = localStorage.getItem('admin_token');
    if (!token) {
      setError('No authentication token found. Please log in again.');
      navigate('/admin-login');
      return;
    }

    try {
      const response = await axios.post(
        'https://valleyapi-dr9y.onrender.com/api/countries/add',
        {
          Country: formData.Country,
          Shipping_Cost: parseFloat(formData.Shipping_Cost) || 0,
          Taxes: parseFloat(formData.Taxes) || 0,
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      setSuccess('Country added successfully!');
      setFormData({ Country: '', Shipping_Cost: '', Taxes: '' });
      setTimeout(() => navigate('/admin/countries'), 2000); // Redirect after 2 seconds
    } catch (err) {
      console.error('❌ Error al agregar país:', err.message, err.response?.data);
      if (err.response?.status === 401) {
        setError('Unauthorized: Invalid or expired token. Please log in again.');
        localStorage.removeItem('admin_token');
        navigate('/admin-login');
      } else {
        setError(`Failed to add country: ${err.response?.data?.error || err.message}`);
      }
    }
  };

  if (loading) {
    return (
      <div className="countries-page">
        <div className="countries-container">
          <div className="loading-spinner" aria-live="polite">
            <span className="spinner"></span> Loading...
          </div>
        </div>
      </div>
    );
  }

  if (!admin || admin.role !== 'admin') {
    return (
      <div className="countries-page">
        <div className="countries-container">
          <div className="error-message">Access Denied: Admin privileges required.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="countries-page">
      <div className="countries-container">
        <h1>Add New Country</h1>
        <form onSubmit={handleSubmit} className="countries-form">
          <div className="form-group">
            <label htmlFor="Country">Country Name:</label>
            <input
              type="text"
              id="Country"
              name="Country"
              value={formData.Country}
              onChange={handleChange}
              placeholder="Enter country name"
              required
              className="country-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="Shipping_Cost">Shipping Cost:</label>
            <input
              type="number"
              id="Shipping_Cost"
              name="Shipping_Cost"
              step="0.01"
              min="0"
              value={formData.Shipping_Cost}
              onChange={handleChange}
              placeholder="Enter shipping cost"
              required
              className="country-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="Taxes">Taxes:</label>
            <input
              type="number"
              id="Taxes"
              name="Taxes"
              step="0.01"
              min="0"
              value={formData.Taxes}
              onChange={handleChange}
              placeholder="Enter taxes"
              required
              className="country-input"
            />
          </div>
          <div className="countries-actions">
            <button type="submit" className="action-button add-country-btn">
              <span className="add-country-btn-icon">➕</span> Add Country
            </button>
            <button
              type="button"
              className="action-button cancel-btn"
              onClick={() => navigate('/admin/countries')}
            >
              Cancel
            </button>
          </div>
          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}
        </form>
      </div>
    </div>
  );
};

export default AddCountryForm;